/* eslint-disable import/no-cycle */
import { createSlice } from '@reduxjs/toolkit';
import { getCaptcha, getGeneralSettings, getLiscenseDetails, verifyCaptcha } from './authActions';

const initialState = {
    user: null,
    liscense: null,
    showCopyright: false,
    generalSettings: null,
    liscenseLoading: false,
    captchaDetails: null,
    emailOtp: null,
    verifyOtp: null,
};

export const sharedSlice = createSlice({
    name: 'sharedSlice',
    initialState,
    reducers: {
        signIn: (state, action) => ({
            ...state,
            user: {
                ...action.payload,
                // isEditor: action.payload?.app_type?.includes(
                //     'APCM' || 'APCM_Authorizer' || 'APCM_APCM_Executor',
                // ),
            },
        }),
        setCopyright: (state, action) => ({
            ...state,
            showCopyright: action.payload,
        }),
        setLiscenseLoading: (state, action) => ({
            ...state,
            liscenseLoading: action.payload,
        }),
        setLiscenseDetails: (state, action) => ({
            ...state,
            liscense: action.payload,
        }),
        
        clearAuthSource: state => ({
                ...state,
                emailOtp: [],
                verifyOtp: [],
        }),
    },
    extraReducers: builder => {
        builder
            .addCase(getLiscenseDetails.fulfilled, (state, action) => ({
                ...state,
                liscense: action.payload,
            }))
            .addCase(getGeneralSettings.fulfilled, (state, action) => ({
                ...state,
                generalSettings: action.payload,
            }))
            .addCase(getCaptcha.fulfilled, (state, action) => ({
                    ...state,
                    captchaDetails: action.payload,
            }))
            .addCase(verifyCaptcha.fulfilled, (state, action) => ({
                    ...state,
                    emailOtp: action.payload,
            }));
    },
});

export const { signIn, setCopyright, setLiscenseLoading, setLiscenseDetails, clearAuthSource } =
    sharedSlice.actions;
export const getUnitIds = state => state.auth?.user?.unit_id;
export const getParsedUnitIds = state => {
    const unitIds = state.auth?.user?.unit_id;
    return JSON.parse(unitIds);
};
export const getIsEditor = state => state.auth?.user?.isEditor;
export const getUserPermissions = state => {
    const permissions = state.auth?.user?.permissions;
    if (permissions) {
        return JSON.parse(permissions);
    }
    return [];
};

export const getLiscenseValidity = state => state.auth?.liscense;

export const getCopyrightVisibility = state => state.auth?.showCopyright;

export const getCustomerName = state =>
    state.auth?.generalSettings?.customer_id;

export const getUser = state => state.auth?.user;

export const isLiscenseLoading = state => state.auth?.liscenseLoading;
export const getOtpResponse = state => state.auth?.emailOtp;

export default sharedSlice.reducer;
